import styled from 'styled-components'
import { colors } from '../../styles'

export const StyledHeader = styled.header`
  background-color: ${colors.grey};
  display: flex;
  align-items: center;
  padding: 0 24px;
  min-height: 48px;

  & > .logo {
    color: ${colors.white};
    margin-right: 28px;
  }

  & > .search {
    flex: 1;
  }
`
